import React, { useCallback, useState } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, LabelList, ComposedChart, Scatter, ScatterChart, ZAxis } from 'recharts';
import {EuiFlexGroup, EuiFlexItem, EuiFlexGrid, EuiSpacer, EuiEmptyPrompt, EuiTable, EuiTableBody, EuiTableRowCell, EuiTableRow, EuiButton, EuiButtonIcon, EuiLoadingSpinner } from '@elastic/eui';
// import { toIntString } from '../../../../../../shared/utils/numbers';
import numeral from "numeral";
// import { group } from 'node:console';
import html2canvas from 'html2canvas';
import {openPDF} from "../../../../shared/Components/Pdf";
import './styles.css';
import informe from '../Report'
import { useMemo } from 'react';
import { COLUMNSREPORT,SUBTITLESREPORT } from './../TablaInforme/columns';
import downArrow from './../../../../shared/Icons/down.png';
import upArrow from './../../../../shared/Icons/up.png';

export const GraficosBarras = (props) =>{

    const {data, periodo, año, tipo, moneda, showMaskWater, showAnimation} = props;

    let [isLoading, setIsLoading] = useState(false);

    const toIntString = number => {
        var strFormat = "0,0";
        if(number < 0) strFormat = "(0,0)";
        return numeral(number).format(strFormat);
    };

    const toDifString = vArray => {
        var number = vArray[1] - vArray[0];
        var strFormat = "0,0";
        if(number < 0) strFormat = "(0,0)";
        return numeral(number).format(strFormat);
    };

    const toDecimalString = number => {
        var strFormat = "0.00";
        if(number < 0) strFormat = "(0.00)";
        return numeral(number).format(strFormat);
    };

    const getData = (data, prop) => {
        var vSuma = 0;
        var groups = [];
        for(var i = 0; i<=data.length-1;i++){
            if(!data[i].noMostrar){
                var vNivel = data[data.length -1].nivel;
                var vData = (vNivel == data[i].nivel ? 'zzzzzzzz' : '') + data[i].orden;
                groups[vData] = groups[vData] || {idCentro: data[i].idCentro, totalGraf: [], val: 0, internacional: 0,nacional: 0, porc: 0, porcObj: 0, z: 1};
                groups[vData].totalGraf = (data[i].idPais == '@@' ? [(vNivel == data[i].nivel ? 0 : vSuma), (vNivel == data[i].nivel ? 0 : vSuma )+ data[i][prop]] : groups[vData].totalGraf);
                groups[vData].val = (data[i].idPais == '@@' ? data[i][prop] : groups[vData].val);
                groups[vData].porc = (data[i].idPais == '@@' ? data[i]['porc' + prop] : groups[vData].porc);
                groups[vData].porcObj = (data[i].idPais == '@@' ? data[i]['porcObj' + prop.charAt(0).toUpperCase() + prop.slice(1)] : groups[vData].porcObj);
                groups[vData].internacional = (data[i].idPais == '99' ? data[i][prop] : groups[vData].internacional);
                groups[vData].nacional = (data[i].idPais == '00' ? data[i][prop] : groups[vData].nacional);
            }
            if(data[i].idPais == '@@') vSuma = vSuma+ data[i][prop];
            
        }
        
        return Object.values(groups);
    }

    

    const getAporBDIData = (data) => {
        var vSuma = 0;
        var groups = [];
        for(var i = 0; i<=data.length-1;i++){
            if(!data[i].noMostrar){
                var vNivel = data[data.length -1].nivel;
                var vData = (vNivel == data[i].nivel ? 'zzzzzzzz' : '') + data[i].orden;
                groups[vData] = groups[vData] || {idCentro: data[i].idCentro, Aportacion: 0, BDI: 0, internacional: 0,nacional: 0, porc: 0, porcObj: 0, z: 1};
                groups[vData].Aportacion = (data[i].idPais == '@@' ? data[i].apor : groups[vData].Aportacion);
                groups[vData].porc = (data[i].idPais == '@@' ? data[i].porcapor : groups[vData].porc);
                groups[vData].porcObj = (data[i].idPais == '@@' ? data[i].porcObjApor : groups[vData].porcObj);
                groups[vData].BDI = (data[i].idPais == '@@' ? data[i].bdi : groups[vData].BDI);
                groups[vData].Aportacion_int = (data[i].idPais == '99' ? data[i].apor : groups[vData].Aportacion_int);
                groups[vData].BDI_int = (data[i].idPais == '99' ? data[i].bdi : groups[vData].BDI_int);
                groups[vData].Aportacion_nac = (data[i].idPais == '99' ? data[i].apor : groups[vData].Aportacion_nac);
                groups[vData].BDI_nac = (data[i].idPais == '99' ? data[i].bdi : groups[vData].BDI_nac);
            }
        }
        
        return Object.values(groups);
    }

    const getCentros = (data, prop) => {
        var vSuma = 0;
        var groups = [];
        for(var i = 0; i<=data.length-1;i++){
            if(!data[i].noMostrar){
                var vNivel = data[data.length -1].nivel;
                var vData = (vNivel == data[i].nivel ? 'zzzzzzzz' : '') + data[i].orden;
                groups[vData] = groups[vData] || {idCentro: data[i].idCentro, centro: data[i].centro};
            }            
        }
        
        var vTexto = 'Centros mostrados: ';
        Object.values(groups).forEach( x => {
            vTexto += x.idCentro + ' - ' + x.centro +', ';
        });

        return vTexto.slice(0,-2);
    }

    const renderCustomizedLabel = (props) => {
        console.log('props label', props)
        const { x, y, width, height, value } = props;
        const radius = 17;
        const vColor = (value < 0.8 ? "red" :"#003f87" );
      
        return (
          <g>
            <text x={x} y={y} color={vColor} fill={vColor} font-weight="bold" font-size="small" offset="5" class="recharts-text recharts-label" text-anchor="middle">
                <tspan x={x + width/2} y={y + height/2} dy="0.355em">
                    {toDecimalString(value)}
                </tspan>
            </text>
          </g>
        );
      };

    const getGrafico = (pData, pTexto) =>{
        var respProps = {};
        if(!(showAnimation ?? true)){
            respProps={width:710, height: Math.round(window.innerHeight*0.35)-15}
        }
        return <div style={{ maxHeight: Math.round(window.innerHeight*0.35) + 'px', marginBottom: '120px'}}>
                <p style={{color: '#003f87',fontWeight: 'bold', marginTop: '15px', marginLeft: '15px'}}>{pTexto}</p>
                {/* <EuiTable id='Tabla-IPobj' style={{marginLeft: '3%', marginRight: '3%', width: '93%'}} responsive>
                    <EuiTableBody>{renderIPobjRows(pData)}</EuiTableBody>
                </EuiTable> */}
                <ResponsiveContainer {...respProps}>
                <ComposedChart
                    width={600}
                    height={300}
                    data={pData}
                    margin={{
                        top: 40,
                        right: 40,
                        left: 40,
                        bottom: 10,
                    }}  isAnimationActive={showAnimation ?? true}>
                    <CartesianGrid vertical={false} />
                    <XAxis dataKey="idCentro" />
                    <XAxis dataKey="porc"  axisLine={false} tickLine={false} tick={renderXporcTick} interval={0} scale="auto" xAxisId="quarter" />
                    <YAxis hide={true} domain={['dataMin', dataMax => (dataMax * ((tipo == 'GRTEND' || tipo == 'GRREAL') ? 1.3 : 1) )]} />
                    {(tipo == 'GRTEND' || tipo == 'GRREAL') && <YAxis hide={true} yAxisId="Ejey2" />}
                    {(tipo == 'GRTEND' || tipo == 'GRREAL') && <ZAxis type="number" dataKey="z" domain={[0,1]} scale='pow' range={[10,1100]} />}
                    <Bar dataKey="totalGraf" fill="#003f87" isAnimationActive={showAnimation ?? true}> 
                        <LabelList dataKey="totalGraf" position="top" color="#003f87" offset={15} formatter={toDifString} fill={"#003f87"}  fontWeight='bold'/>
                    </Bar>
                    {(tipo == 'GRTEND' || tipo == 'GRREAL') && <Scatter yAxisId="Ejey2" dataKey="z" fill="#eee"  isAnimationActive={showAnimation ?? true}><LabelList dataKey="porcObj" content={renderCustomizedLabel}/></Scatter>}
                    {/*<Scatter yAxisId="Ejey2" dataKey="z" fill="#eee">
                         <LabelList dataKey="porcObj" color="#003f87" fill="#003f87" formatter={toDecimalString} fontWeight='bold' fontSize='small'/>
                        
                        </Scatter>} */}
                </ComposedChart>
                </ResponsiveContainer>
                <EuiTable id='Tabla-Informe' style={{marginLeft: '3%', width: '96%', background: 'transparent'}} responsive>
                    <EuiTableBody>{renderRows(pData)}</EuiTableBody>
                </EuiTable>
        </div>
    }

    const renderRows=(pData)=> {
        return  <>
                    <EuiTableRow style={{height: 'auto'}}>
                        {pData.map((column, index)=>{
                            return <EuiTableRowCell align={'center'} style={{color:'#003f87' , borderTop: 'none', borderBottom: 'none', fontWeight: 'bold', paddingTop: '6px', paddingBottom: '6px', background: 'transparent'}} > {'Nac. ' + toIntString((column.val == 0 ? 0 : column.nacional / column.val * 100)) + '%' }</EuiTableRowCell>
                        })}
                    </EuiTableRow>
                    <EuiTableRow style={{height: 'auto'}}>
                    {pData.map((column, index)=>{
                            return <EuiTableRowCell align={'center'} style={{color:'#f47c00' , borderTop: 'none', borderBottom: 'none', fontWeight: 'bold', paddingTop: '6px', paddingBottom: '6px', background: 'transparent'}} > {'Int. ' + toIntString((column.val == 0 ? 0 : column.internacional / column.val * 100)) + '%' }</EuiTableRowCell>
                        })}
                    </EuiTableRow>
                </>
    }

    // const renderIPobjRows=(pData)=> {
    //     return  <>
    //                 <EuiTableRow style={{height: 'auto'}}>
    //                     {pData.map((column, index)=>{
    //                         return <EuiTableRowCell align={'center'} style={{color:'#003f87' , borderTop: 'none', borderBottom: 'none', fontWeight: 'bold', paddingTop: '6px', paddingBottom: '6px'}} > <span class="dot"><span class="textoDot">{ toDecimalString(column.porcObj) }</span></span></EuiTableRowCell>
    //                     })}
    //                 </EuiTableRow>
    //             </>
    // }

    const getDataMin = (dataOrig) =>{
        console.log('dataOrig ', dataOrig)
        const minDataBDI = Math.min(...dataOrig.map((e)=> (e.BDI===null ? 0 : e.BDI)))
        const minDataAportacion = Math.min(...dataOrig.map((e)=> (e.Aportacion===null ? 0 : e.Aportacion)))
        const minData = Math.min(...[minDataBDI,minDataAportacion,0])
        // console.log('minData ', minData)
        return minData
    }

    const getGraficoAporBDI = (pData, pTexto) =>{
        var respProps = {};
        if(!(showAnimation ?? true)){
            respProps={width:710, height: Math.round(window.innerHeight*0.35)-15}
        }
        return <div style={{ maxHeight: Math.round(window.innerHeight*0.35) + 'px', marginBottom: '120px'}} id='OcultarZ'>
                    <p style={{color: '#003f87',fontWeight: 'bold', marginTop: '15px', marginLeft: '15px'}}>{pTexto}</p>
                    {/* <EuiTable id='Tabla-IPobj' style={{marginLeft: '3%', marginRight: '3%', width: '93%'}} responsive>
                        <EuiTableBody>{renderIPobjRows(pData)}</EuiTableBody>
                    </EuiTable> */}
                    <ResponsiveContainer {...respProps}>
                        <ComposedChart
                            // width={600}
                            // height={300}
                            data={pData}
                            margin={{
                                top: 40,
                                right: 40,
                                left: 40,
                                bottom: 10,
                            }}  isAnimationActive={showAnimation ?? true}>
                            <CartesianGrid vertical={false} />
                            <XAxis dataKey="idCentro" />
                            <XAxis dataKey="porc"  axisLine={false} tickLine={false} tick={renderXporcTick} interval={0} scale="auto" xAxisId="quarter" />
                            <YAxis hide={true} domain={[dataMin => getDataMin(pData), dataMax => (dataMax * ((tipo == 'GRTEND' || tipo == 'GRREAL') ? 1.3 : 1) )]} />
                            {(tipo == 'GRTEND' || tipo == 'GRREAL') && <ZAxis type="number" dataKey="z" domain={[0,1]} scale='pow' range={[10,1100]} hide={true}/>}
                            {(tipo == 'GRTEND' || tipo == 'GRREAL') && <YAxis hide={true} yAxisId="Ejey2" />}
                            <Legend />
                            <Bar dataKey="Aportacion" fill="#003f87" isAnimationActive={showAnimation ?? true}>
                                <LabelList dataKey="Aportacion" position="top" color="#003f87" offset={15} formatter={toIntString} fill="#003f87"  fontWeight='bold'/>
                            </Bar>
                            <Bar dataKey="BDI" fill="#f47c00" isAnimationActive={showAnimation ?? true}>
                                <LabelList dataKey="BDI" position="top" color="#003f87" offset={15} formatter={toIntString} fill="#f47c00"  fontWeight='bold'/>
                            </Bar>
                            {(tipo == 'GRTEND' || tipo == 'GRREAL') && <Scatter yAxisId="Ejey2" dataKey="z" fill="#eee"><LabelList dataKey="porcObj" content={renderCustomizedLabel}/></Scatter>}
                            {/* {tipo == 'GRTEND' && <Scatter yAxisId="Ejey2" dataKey="z" fill="#eee"><LabelList dataKey="porcObj" color="#003f87" fill="#003f87" formatter={toDecimalString} fontWeight='bold' fontSize='small'/></Scatter>} */}
                        </ComposedChart>
                    </ResponsiveContainer>
                </div>
    }

    const renderLegend = (props) => {
        const { payload } = props;
      console.log('payload',payload);
        return (
            <ul className="recharts-default-legend" /*style="padding: 0px; margin: 0px; text-align: center;"*/>
            {
              payload.map((entry, index) => (
                (entry.value != 'z' ? 
                    <li className={`recharts-legend-item legend-item-${index}`} /*style="display: inline-block; margin-right: 10px;"*/>
                        {/* <svg className="recharts-surface" width="14" height="14" viewBox="0 0 32 32" version="1.1" style="display: inline-block; vertical-align: middle; margin-right: 4px;">
                            <path stroke="none" fill={entry.color} d="M0,4h32v24h-32z" class="recharts-legend-icon"/>
                        </svg> */}
                        <span className="recharts-legend-item-text" /*</li>style="color: rgb(0, 63, 135);" */ >{entry.value}</span>
                    </li>
                : '')
              ))
            }
          </ul>
        );
      }

    const renderXporcTick = (tickProps) => {
        const { x, y, payload } = tickProps;
        const { value, offset } = payload;

        return <><image href={(value > 0 ? upArrow : downArrow)} x={x-40} y={y-15} height="15px" width="15px"/><text x={x} y={y} textAnchor="middle"><span dangerouslySetInnerHTML={{__html: '&nearr;'}} />{`${value} %`}</text></>;

    }

    const getNotData = () => {
        return <EuiEmptyPrompt
          iconType="inspect"
          title={<h2>No se han obtenido datos</h2>}
        />
      }

      const maskWater = useMemo(()=>{
          const show = showMaskWater===true ? true : false;
          return show ? 
          <h1 className='maskWaterGraphic'>{`BORRADOR`}</h1>
          :null
      },[showMaskWater])

    return(
        data && data.length>0 ?
        <>
            <EuiFlexGrid columns={2} direction="row" style={{width:'100%'}} id='AreaImprimirPDF'>
                <EuiFlexGroup>
                <span style={{margin: '9px', color: '#003f87', fontSize: 'small', padding: '15px', width: '100%'}}><span>{getCentros(data, 'cont')}</span><span style={{float: 'right'}}>{`Miles de ${moneda}`}</span></span>
                </EuiFlexGroup>
                <EuiFlexGroup>
                    <EuiFlexItem style={{position:'relative'}}>
                        {getGrafico(getData(data, 'cont'), 'CONTRATACIÓN (' + (tipo == 'GRREAL' ? 'REAL ' + (año -1) + ' - 12)' : (periodo == 2 || periodo == 3 || tipo == 'GRTEND' ? 'TENDENCIA ' : (periodo == 4 ? 'PROPUESTA DE ' : '') + 'OBJETIVOS ') + (periodo == 4 && tipo != 'GRTEND' ? año + 1 : año) + '-Cierre)'))}
                        {maskWater}
                    </EuiFlexItem>
                    <EuiFlexItem style={{position:'relative'}}>
                        {getGrafico(getData(data, 'fact'), 'FACTURACIÓN (' + (tipo == 'GRREAL' ? 'REAL ' + (año -1) + ' - 12)' : (periodo == 2 || periodo == 3 || tipo == 'GRTEND' ? 'TENDENCIA ' : (periodo == 4 ? 'PROPUESTA DE ' : '') + 'OBJETIVOS ') + (periodo == 4 && tipo != 'GRTEND' ? año + 1 : año) + '-Cierre)'))}
                        {maskWater}
                    </EuiFlexItem>
                </EuiFlexGroup>
                <EuiFlexGroup>
                    <EuiFlexItem style={{position:'relative'}}>
                        {getGraficoAporBDI(getAporBDIData(data), 'APORTACIÓN / BDI (' + (tipo == 'GRREAL' ? 'REAL ' + (año -1) + ' - 12)' : (periodo == 2 || periodo == 3 || tipo == 'GRTEND'  ? 'TENDENCIA ' : (periodo == 4 ? 'PROPUESTA DE ' : '') + 'OBJETIVOS ') + (periodo == 4 && tipo != 'GRTEND' ? año + 1 : año) + '-Cierre)'))}
                        {maskWater}
                    </EuiFlexItem>
                    <EuiFlexItem style={{position:'relative'}}>
                        {getGrafico(getData(data, 'prod'), 'PRODUCCIÓN (' + (tipo == 'GRREAL' ? 'REAL ' + (año -1) + ' - 12)' : (periodo == 2 || periodo == 3 || tipo == 'GRTEND' ? 'TENDENCIA ' : (periodo == 4 ? 'PROPUESTA DE ' : '') + 'OBJETIVOS ') + (periodo == 4 && tipo != 'GRTEND' ? año + 1 : año) + '-Cierre)'))}
                        {maskWater}
                    </EuiFlexItem>
                </EuiFlexGroup>
            </EuiFlexGrid>
        </>
        :getNotData()
      )

    // return(
    //     data && data.length>0 ?
    //     <>            
    //         {/* <EuiFlexGroup justifyContent="spaceAround">
    //             <EuiFormRow>
    //                 <EuiFlexItem >
    //                     <EuiSpacer size="xl"/>
    //                     {fnIsLoading(isLoading)}
    //                 </EuiFlexItem>
    //             </EuiFormRow>
    //         </EuiFlexGroup> */}
    //         <EuiFlexGroup id='AreaImprimirPDF'>
    //             <EuiFlexItem>
    //                 <EuiSpacer size="m"/>
    //                 <EuiFormRow >
    //                     <EuiFlexGroup>
    //                         <EuiFlexItem width={8}>
    //                             {getGrafico(getData(data, 'cont'), 'CONTRATACIÓN (' + (periodo == 4 ? 'PROPUESTA DE ' : '') + 'OBJETIVOS ' + año + '-Cierre)')}
    //                         </EuiFlexItem>
    //                         <EuiFlexItem width={8}>
    //                             {getGrafico(getData(data, 'fact'), 'FACTURACIÓN (' + (periodo == 4 ? 'PROPUESTA DE ' : '') + 'OBJETIVOS ' + año + '-Cierre)')}
    //                         </EuiFlexItem>
    //                     </EuiFlexGroup>
    //                 </EuiFormRow>
    //                 <EuiFormRow >
    //                     <EuiFlexGroup>
    //                         <EuiFlexItem width={8}>
    //                             {getGraficoAporBDI(getAporBDIData(data), 'APORTACIÓN / BDI (' + (periodo == 4 ? 'PROPUESTA DE ' : '') + 'OBJETIVOS ' + año + '-Cierre)')}
    //                         </EuiFlexItem>
    //                         <EuiFlexItem width={8}>
    //                             {getGrafico(getData(data, 'prod'), 'PRODUCCIÓN (' + (periodo == 4 ? 'PROPUESTA DE ' : '') + 'OBJETIVOS ' + año + '-Cierre)')}
    //                         </EuiFlexItem>
    //                     </EuiFlexGroup>
    //                 </EuiFormRow>
    //             </EuiFlexItem>
    //         </EuiFlexGroup>
    //     </>
    //     :getNotData()
    //   )
}
